<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.sector_news')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
        <section class="section py-3">
            <div class="container">
                <div class="tab_div_top">
                    <el-row :gutter="15">
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3" v-for="item in news">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link :to="`/newsview?id=${item.id}`">
                                    <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                         class="card-img-top">
                                    <span class="press_sektornews_status">{{$t('submenu.sector_news')}}</span>
                                    <blockquote class="card-blockquote">
                                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 583 95"
                                             class="svg-bg">
                                            <polygon points="0,52 583,95 0,95"
                                                     class="fill-defaultnew"></polygon>
                                            <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                                     class="fill-default"></polygon>
                                        </svg>
                                        <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                        <h4 v-if="$i18n.locale === 'uz-UZ'"
                                            class="display-3 text-titlecolor title_text">
                                            {{item.titleUzLat}}</h4>
                                        <h4 v-if="$i18n.locale === 'uz-CYR'"
                                            class="display-3 text-titlecolor title_text">{{item.titleUz}}</h4>
                                        <h4 v-if="$i18n.locale === 'ru-RU'"
                                            class="display-3 text-titlecolor title_text">{{item.tilteRu}}</h4>
                                        <h4 v-if="$i18n.locale === 'en-US'"
                                            class="display-3 text-titlecolor title_text">{{item.titleEn}}</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                    </el-row>
                    <div style="display: flex; justify-content: center; align-items: center; margin-top: 12px">
                        <el-pagination
                                align="center"
                                background
                                layout="prev, pager, next"
                                @current-change="onPageChange"
                                :current-page.sync="paging.current"
                                :page-size="paging.size"
                                :total="paging.total">
                        </el-pagination>
                        <span style="margin-left: 16px">{{$t('app.bosh_stat')}} {{ paging.total }}</span>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    import moment from "moment";
    export default {
        data() {
            return {
                activeName: 'news',
                pagination: {
                    default: 1
                },
                categoryId: 3,
                news: [],
                paging: {
                    sort: null,
                    page: 0,
                    size: 12,
                    total: 0,
                    current: 1
                }
            }
        },
        methods: {
            loadSectorNews() {
                this.news = [];
                this.$axios.get(`https://www.prokuratura.uz/api/news/page/category/${this.categoryId}?page=${this.paging.page}`).then(response => {
                // this.$axios.get(`http://172.18.45.189:8080/api/news/category/${this.categoryId}?page=${this.paging.page}`).then(response => {
                    this.news = response.data.content;
                    this.paging.total = response.data.totalElements;
                });
            },
            parseDate(dateTime) {
                return moment(dateTime).format("DD.MM.YYYY");
            },
            onPageChange(current) {
                this.paging.current = current;
                this.paging.page = current - 1;
                this.loadSectorNews();
            }
        },
        created() {
            this.loadSectorNews();
        }
    };
</script>
<style scoped>
    .bg-defaultnew {
        background: #fff;
        cursor: pointer;
    }

    .press_news_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(57, 72, 105, 0.85);
    }

    .press_sektornews_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(207, 52, 118, 0.85);
    }

    .tab_div_top {
        min-height: 400px;
        margin-top: 15px;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 88px;
    }

    /deep/ .badge {
        display: inline-block;
        padding: 0.35rem 0.375rem;
        font-size: 76%;
        font-weight: 600;
        margin-left: -6px;
        line-height: 1;
        text-align: center;
        position: absolute;
        white-space: nowrap;
        top: -32px;
        vertical-align: baseline;
        border-radius: 0rem;
    }

    /deep/ .badge-primary {
        color: #394869;
        background-color: #f0f4f9;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 38px;
    }

    /deep/ .card-img-top {
        height: 240px;
        object-fit: cover;
        border-radius: 0px;
    }

    .textnew-title_color {
        color: #394869;
    }
</style>
